import type { FC } from 'react';
import { FullPage } from 'components/Layout/FullPageLayout';
import React from 'react';

import { LoadingText } from '@fragment/ui/src/components/LoadingText';
import { Text } from '@fragment/ui/src/components/Text';

export const TopLevelLoader: FC = () => {
  const wrap = (child: React.ReactNode) => (
    <span
      style={{
        fontFeatureSettings: `'ss01' on`,
        fontVariantLigatures: 'no-contextual',
      }}
    >
      {child}
    </span>
  );

  return (
    <FullPage.Layout>
      {wrap(
        <Text as="span" fontSize="text-fxl">
          <LoadingText text="FRAGMENT" />
        </Text>
      )}
    </FullPage.Layout>
  );
};
